import { cn } from '@goaltree/ui/lib/utils'
import { type ReactNode } from 'react'

export type NodeStatus = 'loading' | 'success' | 'error' | 'initial'

export type NodeStatusIndicatorProps = {
  status?: NodeStatus
  children: ReactNode
}

export const BorderLoadingIndicator = ({ children }: { children: ReactNode }) => (
  <>
    <div className="absolute -left-px -top-px h-[calc(100%+2px)] w-[calc(100%+2px)] animate-pulse rounded-[9px] border-2 border-blue-500/70" />
    {children}
  </>
)

const StatusBorder = ({ children, className }: { children: ReactNode; className?: string }) => (
  <>
    <div
      className={cn(
        'absolute -left-px -top-px h-[calc(100%+2px)] w-[calc(100%+2px)] rounded-[9px] border-2',
        className,
      )}
    />
    {children}
  </>
)

export const NodeStatusIndicator = ({ status, children }: NodeStatusIndicatorProps) => {
  switch (status) {
    case 'loading':
      return <BorderLoadingIndicator>{children}</BorderLoadingIndicator>
    case 'success':
      return <StatusBorder className="border-emerald-500">{children}</StatusBorder>
    case 'error':
      return <StatusBorder className="border-red-400">{children}</StatusBorder>
    default:
      return <>{children}</>
  }
}
